import { ClassStep } from "./ClassStep";
import { AbstractPlayableContent } from "../../../../playable/models/AbstractPlayableContent";
import { ClassType } from "../../types/ClassType";
import { PlayClassProgress } from "./PlayClassProgress";
// False negative
// @ts-ignore
import { createDemoStep } from "./DemoSteps";
import { i18n } from "../../../../../boot/i18n";

export class PlayClass {
  readonly id: number;
  readonly type: ClassType;
  readonly progress: PlayClassProgress;

  readonly playableContent: AbstractPlayableContent;

  readonly requiredClasses: PlayClass[] = [];
  readonly containedClasses: PlayClass[] = [];

  readonly steps: ClassStep[] = [];
  readonly hasDemo: boolean; // TODO: Remove has Demo parameter

  constructor(id: number, type: ClassType, playableContent: AbstractPlayableContent,
    requiredClasses: PlayClass[], containedClasses: PlayClass[], steps: ClassStep[], hasDemo: boolean,
    progress: PlayClassProgress) {
    this.id = id;
    this.type = type;
    this.playableContent = playableContent;

    this.requiredClasses = requiredClasses;
    this.containedClasses = containedClasses;
    this.steps = steps;
    this.hasDemo = hasDemo;

    this.progress = progress;
  }

  get partTypeLabel() {
    switch (this.playableContent.baseModel.part_type) {
      case 'VERSE':
        return `${i18n.t('partClassElement.partType.verse')}${this.playableContent.baseModel.info ? ` - ${this.playableContent.baseModel.info}` : ''}`;
      case 'CHORUS':
        return `${i18n.t('partClassElement.partType.chorus')}${this.playableContent.baseModel.info ? ` - ${this.playableContent.baseModel.info}` : ''}`;
      case 'BRIDGE':
        return `${i18n.t('partClassElement.partType.bridge')}${this.playableContent.baseModel.info ? ` - ${this.playableContent.baseModel.info}` : ''}`;
      case 'INTRO':
        return `${i18n.t('partClassElement.partType.intro')}${this.playableContent.baseModel.info ? ` - ${this.playableContent.baseModel.info}` : ''}`;
      case 'EMPTY':
        return this.playableContent.baseModel.info;
      default:
        return `${i18n.t('partClassElement.partType.other')}${this.playableContent.baseModel.info ? ` - ${this.playableContent.baseModel.info}` : ''}`;
    }
  }

  public getStep(stepId: number): ClassStep {
    return this.steps[stepId];
  }
  public getDemoStep(isStarted: boolean = false) {
    return createDemoStep(this.playableContent, false, isStarted)
  }

  public isAvailable(): boolean {
    // Use === 1 hack for Part classes that only contains One section, if we need different implementation need to use heritage classes
    return this.requiredClasses.length === 0 || this.requiredClasses.every(value => value.progress.isFinished)
  }
  public isAdvised(): boolean {
    // Use === 1 hack for Part classes that only contains One section, if we need different implementation need to use heritage classes
    return this.isAvailable() && (this.containedClasses.length === 1 || this.containedClasses.every(value => value.progress.isFinished))
  }

  public hasAtLeaseOneClassAvailableAndNotFinished(): boolean {
    if (this.containedClasses.length === 0 && !this.progress.isFinished && this.isAvailable()) {
      return true;
    }
    if (this.steps.length > 0 && !this.progress.isFinished && this.isAvailable()) {
      return true;
    }
    return this.containedClasses.some((value) => {
      return value.hasAtLeaseOneClassAvailableAndNotFinished();
    })
  }
}
